<template>
  <div>
    <sc-form 
      autocomplete="off"
      ref="TestForm">

        <template slot="fields" slot-scope="{ fields }">
          <h1>Etapa de teste</h1>
        </template>

        <template slot="actions" slot-scope="{ isValid }">
          <sc-button
            text="Voltar"
            theme="default"
            type="button"
            @click="setActiveStep(3)"/>
          <sc-button
            text="Próximo"
            theme="primary"
            @click="navigateNext"
            type="button"/>
        </template>
      </sc-form>
  </div>
</template>
  
<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScForm,
    ScField,
  } from '@intelipost-js/secure-components';

  const { mapState, mapMutations } = createNamespacedHelpers('integrations/integrationsStep');

  export default {
    name: 'sc-test',

    computed: {
      ...mapState([
        'activeStep',
      ]),
    },
    methods: {
      ...mapMutations([
        'setActiveStep',
      ]),
      navigateNext() {
        this.setActiveStep(5);
      },
    },
    components: {
      ScButton,
      ScForm,
      ScField,
    },
  };
</script>
  
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-test/ScTest.vue